import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useNavigate } from "react-router-dom";

//API
import ItemService from "../../../services/customer_appCommonService";

//Redux
import { useSelector, useDispatch } from "react-redux"; //useDispatch
import { getSupplierCategorySelection } from "../../../redux/feature/supplier_app/supplierSlice";

//Components
import Layout from "../../../Layout/Layout";
import { InputField } from "../../../Components/formElements/InputField";
import { ComboboxField } from "../../../Components/formElements/ComboboxField";
import Constants from "../../../common/CustomerConstants";
import CommonFillter from "../../../Components/Filter/Supplier/SupplierCommonFillter";
import ApproveRemarksModal from "../../../Components/Modal/supplier_app/ApproveRemarksModal";
import toast from "react-hot-toast";
import SuccessModal from "../../../Components/Modal/supplier_app/SuccessModal";
import FileUploadComponent from "../../../Components/formElements/FileUploadComponent";
import FileViewerModal from "../../../Components/FileViewer/FileViewerModal";

const CustomerDetailedPageV4Workflow = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  let selectedCategoryData = useSelector(
    (state) => state?.supplier?.selectedCategory
  ); // User Details from Store
  let userInfo = useSelector((state) => state?.user?.data); // userInfo from Store
  let customerID = useSelector((state) => state?.customer?.customerID); // customerID from Store
  let workflow = useSelector((state) => state?.customer?.customerWorkflow); // customerID from Store
  // console.log(">>workflow",workflow)
  localStorage.setItem("menu", workflow?.page);
  localStorage.setItem("submenu", "-");

  let pageSection = ["CategorySelection"];

  /* success modal */
  const successModalData = {
    title: "Message",
    successMsg: "",
  };
  const [getShowSuccessModal, setShowSuccessModal] = useState(false);
  const [getsucceModalData, setsucceModalData] = useState(successModalData);
  const [getNextNavigate, setNextNavigate] = useState("");
  const onSuccessmodel = () => {
    setShowSuccessModal(true);
  };
  const hideSuccessModal = () => {
    setShowSuccessModal(false);
  };

  let getSecurityDeposit = [
    {
      id: "1",
      name: "Yes",
    },
    {
      id: "2",
      name: "No",
    },
  ];
  let getCustomergroup = [
    {
      id: "01",
      name: "Industry",
    },
    {
      id: "02",
      name: "Retail",
    },
    {
      id: "AC",
      name: "AFL CONGS CUST",
    },
    {
      id: "AD",
      name: "AFL DIRECT CUST",
    },
    {
      id: "AG",
      name: "Agent",
    },
    {
      id: "AT",
      name: "Agent",
    },
    {
      id: "AV",
      name: "Arvind Stores",
    },
    {
      id: "BB",
      name: "Big Bazaar",
    },
    {
      id: "BF",
      name: "Brand Factory",
    },
    {
      id: "BM",
      name: "Big Mega Mart",
    },
    {
      id: "C1",
      name: "Priority 1 - Arun",
    },
    {
      id: "C2",
      name: "Priority 2 - Arun",
    },
    {
      id: "C3",
      name: "Priority 3- Arun",
    },
    {
      id: "CA",
      name: "Cons Sales Agent",
    },
  ];
  let getstoreCityTire = [
    {
      id: "1",
      name: "Tier I",
    },
    {
      id: "2",
      name: "Tier II",
    },
    {
      id: "3",
      name: "Tier III",
    },
    {
      id: "4",
      name: "Tier IV",
    },
    {
      id: "5",
      name: "Tier V",
    },
  ];
  let getCustomerGroup = [
    {
      id: "1",
      name: "STORE",
    },
    {
      id: "2",
      name: "WAREHOUSE",
    },
  ];
  let getStoreType = [
    {
      id: "1",
      name: "HS",
    },
    {
      id: "2",
      name: "MALL",
    },
  ];
  let getRentalType = [
    {
      id: "1",
      name: "OWNED",
    },
    {
      id: "2",
      name: "LEASE",
    },
  ];
  let getOwnershipType = [
    {
      id: "1",
      name: "OWN STORE",
    },
    {
      id: "2",
      name: "FRANCHISEE STORE",
    },
    {
      id: "3",
      name: "MANAGEMENT FRANCHISEE STORE",
    },
  ];
  let getBrandDivisionAttribute = [
    {
      id: "1",
      name: "BTL",
    },
    {
      id: "2",
      name: "HBD",
    },
    {
      id: "3",
      name: "LBD",
    },
    {
      id: "4",
      name: "UNL",
    },
  ];
  let getSoldTopartyGrade = [
    {
      id: "1",
      name: "A - GOOD TURNOVER GOOD",
    },
    {
      id: "2",
      name: "CBAA+ - HIGH TURNOVER HIGH",
    },
    {
      id: "3",
      name: "CBAA++ - HIGHER TURNOVER HGHER",
    },
    {
      id: "4",
      name: "CBAA+++ - TOP TURNOVER TOP",
    },
    {
      id: "5",
      name: "CBAB - REASONABLE TURNOVER REASONABLE",
    },
    {
      id: "6",
      name: "CBAC - OTHERS",
    },
  ];
  let getSoldTopartyFolioCode = [
    {
      id: "1",
      name: "AAP",
    },
    {
      id: "2",
      name: "ABA",
    },
    {
      id: "3",
      name: "ABG",
    },
    {
      id: "4",
      name: "ABR",
    },
    {
      id: "5",
      name: "ABT",
    },
    {
      id: "6",
      name: "ACM",
    },
    {
      id: "7",
      name: "ACR",
    },
    {
      id: "8",
      name: "ACT",
    },
  ];
  let getSoldToPartyTermsofPaymentKey = [
    {
      id: "1",
      name: "TD01 - 1 Day",
    },
    {
      id: "2",
      name: "TD02 - 2 Day",
    },
    {
      id: "3",
      name: "TD03 - 7 Days",
    },
    {
      id: "4",
      name: "TD04 - 30 Days",
    },
    {
      id: "5",
      name: "TD05 - 45 Days",
    },
    {
      id: "6",
      name: "TD06 - 50 Days",
    },
    {
      id: "7",
      name: "TD07 - 33 Days",
    },
    {
      id: "8",
      name: "TD08 - 37 Days",
    },
  ];
  let getTaxClassificationTCSTDS = [
    {
      id: "1",
      name: "TCS",
      code: "TCS Applicable",
      desc: "TCS will be charged on the Invoices",
    },
    {
      id: "2",
      name: "TDS",
      code: "TDS Applicable & Please share the Declaration",
      desc: "TDS will be charged on the Invoices",
    },
  ];
  // eslint-disable-next-line no-unused-vars
  const [data, setData] = useState([]);

  const [isCardVisible, setCardVisible] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [isCardVisible3, setCardVisible3] = useState(true);
  const [isCardVisible5, setCardVisible5] = useState(true);
  const [isCardVisible6, setCardVisible6] = useState(true);
  const [isCardVisible7, setCardVisible7] = useState(true);
  const [isCardVisible8, setCardVisible8] = useState(true);
  const [isCardVisible9, setCardVisible9] = useState(true);
  const [isCardVisible10, setCardVisible10] = useState(true);
  const [isCardVisible11, setCardVisible11] = useState(true);
  const [isCardVisible12, setCardVisible12] = useState(true);
  const [isCardVisible13, setCardVisible13] = useState(true);
  const [isCardVisible14, setCardVisible14] = useState(true);


  const [getDropdownData, setDropdownData] = useState("");
  const [modalShow, setModalShow] = useState(false);

  const [getTitle, setTitle] = useState([]);

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };
  const toggleCardVisibility3 = () => {
    setCardVisible3(!isCardVisible3);
  };
  const toggleCardVisibility5 = () => {
    setCardVisible5(!isCardVisible5);
  };
  const toggleCardVisibility6 = () => {
    setCardVisible6(!isCardVisible6);
  };
  const toggleCardVisibility7 = () => {
    setCardVisible7(!isCardVisible7);
  };
  const toggleCardVisibility8 = () => {
    setCardVisible8(!isCardVisible8);
  };
  const toggleCardVisibility9 = () => {
    setCardVisible9(!isCardVisible9);
  };
  const toggleCardVisibility10 = () => {
    setCardVisible10(!isCardVisible10);
  };
  const toggleCardVisibility11 = () => {
    setCardVisible11(!isCardVisible11);
  };
  const toggleCardVisibility12 = () => {
    setCardVisible12(!isCardVisible12);
  };
  const toggleCardVisibility13 = () => {
    setCardVisible13(!isCardVisible13);
  };
  const toggleCardVisibility14 = () => {
    setCardVisible14(!isCardVisible14);
  };

  const hideModal = () => {
    setModalShow(false);
  };

  const [formInputs, setFormInputs] = useState({
    // organisationName: "",
    companyName: "",
    email: "",
    firstName: "",
    lastName: "",
    roles: ["VENDOR"],
    category: ["VENDOR"],
    address: "",
    address2: "",
    city: "",
    countryCode: "",
    country: "",
    stateRegion: "",
    regionCode: "",
    cityPostalCode: "",
    contactTitle: "",
    contactNumber: "",
    contactfirstName: "",
    contactlastName: "",
    contactEmail: "",
    contactPhoneNr: "",
    companyOwner: "",
    companyLogo: "",
    CompanyBrochure: "",
    commodityServices: "",
    haveICVCertificate: "",
    nameOwer: "",
    icvScore: "",
    icvCertificate: "",
    icvExpiryDate: "",
    vatRegistrationNumber: "",
    vatRegistrationExpiryDate: "",
    tradeLicenseNumber: "",
    tradeLicenseExpiryDate: "",
    BCMPlanPolicy: "",
    dealershipSetupType: "",
    MROcommoditybrand: "",
    brandName: "",
    OverseasTaxRegistrationNumber: "",
    issuingAuthorityAccreditation: "",
    chamberIncorporationCertificate: "",
    chamberIncorporationExpiryDate: "",

    contactDetails: [
      {
        lastName: "",
        firstName: "",
        contactEmail: "",
        contactTitle: "",
        contactNumber: "",
        contactPosition: "",
      },
    ],
    companyCOde: [
      {
        companyCOde: "",
        arvindLifestyle: "",
        arvindTrueBlue: "",
        arvindBeautyBrands: "",
        arvFashionsLtd: "",
        arvindYouthBrands: "",
        valueFashionsRetail: "",
      },
    ],
    businessModal: [
      {
        businessModel: "",
        consignment: "",
        intercompany: "",
        salesReturn: "",
        warehouse: "",
        outright: "",
        valueFashion: "",
      },
    ],
    channel: [
      {
        exclusiveBrand: "",
        onlineOn: "",
        exportEx: "",
        multiBrandOutlet: "",
        liquidationLq: "",
        institutional: "",
        keyAccounts: "",
        commonChannel: "",
        marketPlace: "",
      },
    ],
    brandDivision: [
      {
        usPolo: "",
        arrow: "",
        fltingmachine: "",
        bayIsland: "",
        unlimited: "",
        rufandTuf: "",
        theChildreanPlace: "",
        nautica: "",
        gap: "",
        aeropostale: "",
        aeroJeans: "",
        innerwear: "",
        Izod: "",
        arvingPvtLabel: "",
        newPort: "",
        aspol: "",
        elle: "",
        wonderBra: "",
        Excalibur: "",
        footwearFc: "",
        calvinKein: "",
        ailNnow: "",
        trueBlue: "",
        sephora: "",
        commonBrand: "",
        subBrandLevel: "",
        fashions: "",
        footwear: "",
        fashions1: "",
        footwear1: "",
        footwear2: "",
        fashions2: "",
        fashions3: "",
        footwear3: "",
      },
    ],
    shipToParty: [
      {
        titleText: "",
        name11: "",
        street1: "",
        street2: "",
        searchTerm: "",
        state: "",
        mobile: "",
        email11: "",
        city: "",
        country: "",
        telephone: "",
        reqId: "",
        street3: "",
      },
    ],
    otherDetails: [
      {
        gstinNr: "",
        panNr: "",
        foloiCode: "",
        grade: "",
        areaSalesManager: "",
        mobileNr: "",
        telePhoneNr: "",
        emailId: "",
        carpetArea: "",
        creditLimit: "",
        termsofPaymentKey: "",
      },
    ],
    customerGroup: [
      {
        customerGroup: "",
        deliverPlant: "",
        currency: "",
      },
    ],
    ApplicationSorConsignment: [
      {
        storeCityTire: "",
        multipleBrands: "",
        cutomerGroup1: "",
        storeType: "",
        cityClassifications: "",
        rentalType: "",
        ownershipType: "",
        brandDivisionAttribute: "",
      },
    ],
    payerDetails: [
      {
        payerTitleText: "",
        payerName: "",
        payerStreet1: "",
        payerStreet2: "",
        payerSearchTerm: "",
        payerState: "",
        payerMobile: "",
        payerEmail: "",
        payerCity: "",
        payerCountry: "",
        payerTelephone: "",
        payerReqId: "",
        payerStreet3: "",
      },
    ],
    billToParty: [
      {
        billTitleText: "",
        billName: "",
        billStreet1: "",
        billStreet2: "",
        billSearchTerm: "",
        billState: "",
        billMobile: "",
        billEmail: "",
        billCity: "",
        billCountry: "",
        billTelephone: "",
        billReqId: "",
        billStreet3: "",
      },
    ],
    otherInformation: [
      {
        mouLoi: "",
        custodianCheque: "",
        signedCopyReceived: "",
        bankGurantee: "",
        enterInRs: "",
        enterInRs1: "",
      },
    ],
    marginDetails: [
      {
        marginDetails: "",
        baseMargin: "",
        specialMargin: "",
        specialMarginAdd: "",
        dealerMargin: "",
        stoMargin: "",
        scaleWise: "",
        y007y014: "",
        scaleWise1: "",
        articleBasedPricing: "",
      },
    ],
    taxClassifications: [
      {
        taxgstinNr: "",
        taxpanNr: "",
      },
    ],
  });

  const [getDisabledStatus, setDisabledStatus] = useState(true);
  
  const [getCountry, setCountry] = useState([]);
  const [getState, setState] = useState([]);
  const [getAction, setAction] = useState("");

  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);

  const [contactDetail, setContactDetail] = useState([]);

  const [getDocumentTypeData, setDocumentTypeData] = useState([
    {
      id: Date.now(),
      name: "Document 1",
      documentType: "",
      documentNumber: "",
      issueDate: "",
      issuingAuthority: "",
    },
  ]);

  const [getTcsTdsApplicabel, setTcsTdsApplicabel] = useState();
  const [getTcsTdsInvoice, setTcsTdsInvoice] = useState();
 
  // Commmon OnChange of the input scetion
  const onInputChange = ({ target: { name, type, value, checked } }) => {
    // setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
    setFormInputs((formInputs) => ({
      ...formInputs,
      [name]: type === "checkbox" ? checked : value,
    }));
  };
  useEffect(() => {
    // console.log(">>Check getDropdownData Data", getDropdownData);
    if (getDropdownData?.codeType === "country") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
      getStateData(getDropdownData?.code);
    }
    if (getDropdownData?.textCode === "taxClassificationTCSTDSCode") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
      // getStateData(getDropdownData?.code);()
      setTcsTdsApplicabel(getDropdownData?.code);
      setTcsTdsInvoice(getDropdownData?.desc);
    } else {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    }   
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDropdownData]);

  // Get Dropdown data select
  useEffect(() => {
    if (getDropdownData?.name) {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
      }));
      getStateData(getDropdownData?.code);
    } else {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDropdownData]);

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      dispatch(getSupplierCategorySelection()); // getSupplierCategorySelection store
      getMasterData(); // Load Master Data
    }
    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const [nonInvitedDisable, setNonInvitedDisable] = useState(true);
  const [inRegisterdDisable, setInRegisterdDisable] = useState(true);
  const [getRole, setRole] = useState();
  console.log();
  useEffect(() => {
    setRole(userInfo?.roles[0]?.roleId);
  }, [userInfo]);

  useEffect(() => {
    if (getRole === "CommercialTeam") {
      setNonInvitedDisable(false);
    } else {
      setNonInvitedDisable(true);
    }
  }, [getRole]);
  useEffect(() => {
    if (getRole === "MDM") {
      setInRegisterdDisable(false);
    } else {
      setInRegisterdDisable(true);
    }
  }, [getRole]);

  const loadFirstLevelData = async (page) => {
    // setLoading(true);
    if (customerID) {
      let obj = {
        userId: customerID,
      };

      const toastId = toast.loading("Loading...", {
        position: "top-right",
      });

      await ItemService.getUserDetail(obj).then((item) => {
        if (item?.status === 200) {
          setDisabledStatus(true);
          // setHeaderData(item?.data);
          setFormInputs(item?.data);
          setDocumentTypeData(item?.data?.documentTypeData);
          setContactDetail(item?.data?.contactDetails);
          //  setLoading(false);
          // setInitalData(item.data?.vendorCategory);
          // item.data?.bankDetails
          //   ? setBankDetails(item.data?.bankDetails)
          //   : setBankDetails([...getBankDetails, bankInfoInitialData]);
          // item.data?.contactDetails
          //   ? setContactAddress(item.data?.contactDetails)
          //   : setContactAddress([...getContactAddress, contactAddressData]);
        } else {
          toast.error(item?.message || "Please try again !!", {
            duration: 4000,
            position: "top-right",
          });
        }
        toast.dismiss(toastId);
      });
    } else {
      navigate(Constants.INBOX);
    }
  };

  useEffect(() => {
    loadFirstLevelData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Datatables
  const fetchUsers = async (page) => {
    // setLoading(true);
    setData((prevItems) => {
      // Remove items from prevItems that are not in newItems
      const filteredPrevItems = prevItems.filter((item) => {
        return selectedCategoryData.some(
          (newItem) => newItem.CategoryCode === item.CategoryCode
        );
      });
      // Merge filteredPrevItems with newItems (add new items or update existing ones)
      const updatedItems = [
        ...filteredPrevItems.map(
          (item) =>
            selectedCategoryData.find(
              (newItem) => newItem.CategoryCode === item.CategoryCode
            ) || item
        ),
        ...selectedCategoryData.filter(
          (newItem) =>
            !filteredPrevItems.some(
              (item) => item.CategoryCode === newItem.CategoryCode
            )
        ),
      ];
      return updatedItems;
    });

    // setTotalRows(selectedCategoryData?.length);
    // setLoading(false);
  };

  useEffect(() => {
    fetchUsers(1); // fetch page 1 of users
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCategoryData]);


  //Load Master Data
  const getMasterData = async () => {
    let obj0 = {
      codeType: "country",
    };
    await ItemService.getMasterData(obj0).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        setCountry(item?.data);
      } else {
        setCountry([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
    
    let obj4 = {
      codeType: "title",
    };
    await ItemService.getMasterDataSelf(obj4).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        setTitle(item?.data);
      } else {
        setTitle([]);
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });
  };

  // Onselect of Country state will load
  const getStateData = async (code) => {
    let obj1 = {
      codeType: "region",
      code: code,
    };
    await ItemService.getMasterData(obj1).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        setState(item?.data);
      } else {
        setState([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
  };

  const navigateToWorkflow = () => {
    if (workflow?.page === "Inbox") {
      navigate(Constants.INBOX);
    } else {
      navigate(Constants.OUTBOX);
    }
  };

  const showApproveModal = async (name) => {
    setModalShow(true);
    setAction(name);
  };

  const workflowApproveReject = async (remarks) => {
    let obj = {};
    let bodyObj = workflow?.workflow_record?.workflowActionAPI?.Body;

    obj._id = workflow?.workflow_record?._id;
    obj.businessComponentId = workflow?.workflow_record?.businessComponentId;
    obj.eventId = workflow?.workflow_record?.eventId;
    obj.businessComponentInstanceId =
      workflow?.workflow_record?.businessComponentInstanceId;
    obj.stepId = workflow?.workflow_record?.stepId;
    obj.action = getAction;
    obj.remark = remarks;
    obj.editContextData = workflow?.workflow_record?.editContextData;
    obj.editForm = workflow?.workflow_record?.editForm;

    // Add formInputs and other data to payload
    obj.data = {
      // vendorCategory: data.length === 0 ? initalData : data,
      ...formInputs,
      getTcsTdsInvoice: getTcsTdsInvoice || "",
      getTcsTdsApplicabel: getTcsTdsApplicabel || "",
    };

    let newObj = { ...bodyObj, ...obj };
    // console.log(">>newObj", newObj);

    await ItemService.workflowApproveReject(newObj).then((item) => {
      if (item?.status === 200) {
        successModalData.successMsg = "Successfully " + getAction;
        setsucceModalData(successModalData);
        setNextNavigate(Constants.INBOX);
        onSuccessmodel();
      } else {
        console.log(">> Error: Loading workflowApproveReject");
      }
    });
  };

  const handleValueChange = (remarks) => {
    workflowApproveReject(remarks);
  };

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      const hasCommonValues = pageSection.some((item) =>
        workflow?.workflow_record?.editSection?.includes(item)
      );
      if (hasCommonValues) {
        if (workflow?.workflow_record?.editForm) {
          // setPageBlockStatus(true);
        }
      }
    }

    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workflow]);
  const onSuccessUploadDocumentType = (data) => {
    setFormInputs((formInputs) => ({
      ...formInputs,
      [data.fieldName]: data.attachmentId,
    }));
  };
  //show view fiels
  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };


  const exclusiveKeys = [
    "consignment",
    "saleorReturn",
    "outright",
    "interCompany",
    "warehouse",
  ];
  const exclusiveKeys2 = [
    "exclusiveBrandOutlet",
    "multiBrandOutlet",
    "keyAccounts",
    "online",
    "liquidation",
    "institutional",
    "export",
    "marketplace",
    "commonChannel",
  ];

  const checkBoxChange = ({ target: { name, type, value, checked } }) => {
    setFormInputs((prev) => {
      const updatedState = { ...prev };

      // Handle exclusiveKeys group
      if (exclusiveKeys.includes(name)) {
        exclusiveKeys.forEach((key) => {
          updatedState[key] = false;
        });
        updatedState[name] = checked;
        return updatedState;
      }

      // Handle exclusiveKeys2 group
      if (exclusiveKeys2.includes(name)) {
        exclusiveKeys2.forEach((key) => {
          updatedState[key] = false;
        });
        updatedState[name] = checked;
        return updatedState;
      }

      // Handle all other checkboxes
      return {
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      };
    });
  };

  const isExclusiveKeys1True = exclusiveKeys.some((key) => formInputs[key]);
  const isExclusiveKeys2True = exclusiveKeys2.some((key) => formInputs[key]);
  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">
              Registration Approval Workflow:{" "}
              <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                {customerID}
              </span>
            </h2>
            <p className="subText">Information </p>
            <hr />

            <Row className="mb-4">
              <Col xs={12} md={4} lg={4} className="text-left">
                <button
                  className="btnBack"
                  onClick={() => navigateToWorkflow()}
                >
                  <i className="bi bi-arrow-return-left"></i> Go Back
                </button>
              </Col>
              <Col xs={12} md={8} lg={8} className="text-right">
                {workflow?.workflow_record?.decision?.length > 0 &&
                  workflow?.workflow_record?.decision?.map((item, index) => (
                    <button
                      className={
                        item === "Approve" || item === "Submit"
                          ? "btnCommon btn-approve"
                          : "btnCommon btn-danger"
                      }
                      onClick={() => showApproveModal(item)}
                      key={index}
                    >
                      <i
                        className={
                          item === "Approve" || item === "Sumbit"
                            ? "bi bi-check2-circle"
                            : "bi bi-x-circle"
                        }
                      ></i>{" "}
                      {item}
                    </button>
                  ))}
              </Col>
            </Row>

            {(formInputs.status === "Non Invited" ||
              formInputs.status === "Invited" ||
              formInputs.status === "In Registration" ||
              formInputs.status === "Reject" ||
              formInputs.status === "Registered") && (
              <>
                {/* isCardVisible  */}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">BI</span>
                        </Col>
                        <Col xs={8} md={9} lg={9}>
                          <span className="headerTitle">Primary Data</span>
                          <span className="subHeaderTitle">
                            Primary Details
                          </span>
                        </Col>
                      </Row>
                    </h2>

                    <div
                      className={`accordion-collapse collapse show ${
                        isCardVisible ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4">
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Customer Name"
                              extraLabel="As per the trade license"
                              name="organisationName"
                              placeholder=""
                              value={formInputs?.organisationName || ""}
                              onChange={onInputChange}
                              required={true}
                              // error={validation.organisationName}
                              disabled={getDisabledStatus}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label=" Address Lines 1 / Street"
                              name="address"
                              placeholder=""
                              value={formInputs?.address || ""}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                              // error={validation.address}
                              required={true}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Address Line 2"
                              name="address2"
                              placeholder=""
                              value={formInputs?.address2 || ""}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                              // error={validation.address2}
                              required={true}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="City"
                              name="city"
                              placeholder=""
                              value={formInputs?.city || ""}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                              // error={validation.city}
                              required={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Country"
                              placeholder=""
                              data={getCountry}
                              id="country"
                              iconClassName="dropdownIcon"
                              name="country"
                              // code="countryCode"
                              // description="countryDesc"
                              setValue={formInputs?.country}
                              getvalue={setDropdownData}
                              required={true}
                              disabled={getDisabledStatus}
                              // error={validation.country}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="State"
                              placeholder=""
                              data={getState}
                              id="state"
                              iconClassName="dropdownIcon"
                              name="state"
                              code="stateCode"
                              description="stateDesc"
                              setValue={formInputs?.state}
                              getvalue={setDropdownData}
                              required={true}
                              disabled={getDisabledStatus}
                              // error={validation.state}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Postal Code/PO Box"
                              name="cityPostalCode"
                              placeholder=""
                              value={formInputs?.cityPostalCode || ""}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                              // error={validation.cityPostalCode}
                              required={true}
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Contact Person isCardVisible3 */}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible2
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility2}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">CP</span>
                        </Col>
                        <Col xs={4} md={9} lg={9}>
                          <span className="headerTitle">Contact Person</span>
                          <span className="subHeaderTitle">
                            Contact Person Details
                          </span>
                        </Col>                     
                        <Col xs={2} md={1} lg={1} className="">
                          <CommonFillter />
                        </Col>
                      </Row>
                    </h2>

                    {/* Banker Information */}
                    <div
                      className={`accordion-collapse collapse show ${
                        isCardVisible2 ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body">
                        {/* To Load Dynamic Bank Info Form */}
                        {contactDetail &&
                          contactDetail?.map((item, index) => (
                            <div key={index}>
                              <Row className="pt-2 pb-2">
                              
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <ComboboxField
                                    label="Job Title"
                                    placeholder=""
                                    // data={getcontactPosition}
                                    id="contactPosition"
                                    iconClassName="dropdownIcon"
                                    name="contactPosition"
                                    setValue={item?.contactPosition || ""}
                                    getvalue={setDropdownData}
                                    index={index}
                                    // onChangeValue={handleChangeContactInfo}
                                    disabled={getDisabledStatus}
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <ComboboxField
                                    label="Contact Title"
                                    placeholder=""
                                    // data={getTitle}
                                    id="contactTitle"
                                    iconClassName="dropdownIcon"
                                    name="contactTitle"
                                    setValue={item?.contactTitle || ""}
                                    getvalue={setDropdownData}
                                    index={index}
                                    // onChangeValue={handleChangeContactInfo}
                                    disabled={getDisabledStatus}
                                  />
                                </Col>

                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <InputField
                                    className="inputBox"
                                    label="Contact First Name"
                                    name="contactfirstName"
                                    placeholder=""
                                    value={item?.contactfirstName}
                                    // onChange={(e) =>
                                    //   handleChangeContactInfo(
                                    //     index,
                                    //     "contactfirstName",
                                    //     e.target.value
                                    //   )
                                    // }
                                    disabled={getDisabledStatus}
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <InputField
                                    className="inputBox"
                                    label="Contact Last Name"
                                    name="contactlastName"
                                    placeholder=""
                                    value={item?.contactlastName}
                                    // onChange={(e) =>
                                    //   handleChangeContactInfo(
                                    //     index,
                                    //     "contactlastName",
                                    //     e.target.value
                                    //   )
                                    // }
                                    disabled={getDisabledStatus}
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <InputField
                                    className="inputBox"
                                    label="Contact Email"
                                    name="email"
                                    placeholder=""
                                    value={item?.email}
                                    // onChange={(e) =>
                                    //   handleChangeContactInfo(
                                    //     index,
                                    //     "email",
                                    //     e.target.value
                                    //   )
                                    // }
                                    disabled={getDisabledStatus}
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <InputField
                                    className="inputBox"
                                    label="Contact Number"
                                    name="contactNumber"
                                    placeholder=""
                                    value={item?.contactNumber}
                                    // onChange={(e) =>
                                    //   handleChangeContactInfo(
                                    //     index,
                                    //     "contactNumber",
                                    //     e.target.value
                                    //   )
                                    // }
                                    disabled={getDisabledStatus}
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <InputField
                                    className="inputBox"
                                    label="Alternate Contact Number"
                                    name="alternateContactNumber"
                                    placeholder=""
                                    value={item?.alternateContactNumber}
                                    // onChange={(e) =>
                                    //   handleChangeContactInfo(
                                    //     index,
                                    //     "alternateContactNumber",
                                    //     e.target.value
                                    //   )
                                    // }
                                    disabled={getDisabledStatus}
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <InputField
                                    className="inputBox"
                                    label="Alternate Email-ID"
                                    name="alternateEmailId"
                                    placeholder=""
                                    value={item?.alternateEmailId}
                                    // onChange={(e) =>
                                    //   handleChangeContactInfo(
                                    //     index,
                                    //     "alternateEmailId",
                                    //     e.target.value
                                    //   )
                                    // }
                                    disabled={getDisabledStatus}
                                  />
                                </Col>
                              </Row>
                            </div>
                          ))}
                      </div>
                    </div>
                  </div>
                </div>

                {/* customer Document Type isCardVisible2 */}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible3
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility3}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">DT</span>
                        </Col>
                        <Col xs={4} md={9} lg={9}>
                          <span className="headerTitle"> Document Type</span>
                          <span className="subHeaderTitle">Document Type</span>
                        </Col>
                       
                      </Row>
                    </h2>
                    <div
                      // id="acc"
                      className={`accordion-collapse collapse show ${
                        isCardVisible3 ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body">
                        <Row>
                          <Col xs={12} md={12} lg={12}>
                            <div className="accordion-body">
                              <div className="d-flex-column justify-content-center">
                                <Row>
                                  <Col xs={12}>
                                    <div className="accordion-body">
                                      <div className="d-flex-column justify-content-center">
                                        <Row className="pt-4 d-none d-lg-flex ">
                                          <Col xs={12} md={4} lg={2}>
                                            <p className="fs-6 fw-medium d-flex ms-4">
                                              Document Type
                                            </p>
                                          </Col>
                                          <Col xs={12} md={4} lg={2}>
                                            <p className="fs-6 fw-medium d-flex ms-4">
                                              Document Number
                                            </p>
                                          </Col>
                                          <Col xs={12} md={4} lg={2}>
                                            <p className="fs-6 fw-medium d-flex ms-4">
                                              Issue Date
                                            </p>
                                          </Col>
                                          <Col xs={12} md={4} lg={1}>
                                            <p className="fs-6 fw-medium d-flex ms-4">
                                              View Files
                                            </p>
                                          </Col>
                                          <Col xs={12} md={4} lg={2}>
                                            <p className="fs-6 fw-medium d-flex ms-4">
                                              Attachments
                                            </p>
                                          </Col>
                                          <Col xs={12} md={4} lg={2}>
                                            <p className="fs-6 fw-medium d-flex justify-content-center ms-4">
                                              Action
                                            </p>
                                          </Col>
                                        </Row>
                                        {getDocumentTypeData.map(
                                          (doc, index) => (
                                            <Row key={doc.id}>
                                              <Col xs={12}>
                                                <hr className="mx-4 my-0 text-color-black" />
                                              </Col>
                                              <Col
                                                xs={12}
                                                md={4}
                                                lg={2}
                                                className="commTopButtonRightLeftPadding"
                                              >
                                                <ComboboxField
                                                  label=""
                                                  placeholder="Document type"
                                                  // data={getdocumentType}
                                                  id="documentType"
                                                  iconClassName="dropdownIcon"
                                                  name="documentType"
                                                  code="documentTypeCode"
                                                  description="documentTypeDesc"
                                                  setValue={doc?.documentType}
                                                  getvalue={setDropdownData}
                                                  index={doc.id}
                                                  // onChangeValue={handleInputChange}
                                                  disabled={getDisabledStatus}
                                                />
                                              </Col>
                                              <Col
                                                xs={12}
                                                md={4}
                                                lg={2}
                                                className="commTopButtonRightLeftPadding"
                                              >
                                                <InputField
                                                  className="inputBox"
                                                  placeholder="Document Number"
                                                  value={doc.documentNumber}
                                                  // onChange={(e) =>
                                                  //   handleInputChange(
                                                  //     doc.id,
                                                  //     "documentNumber",
                                                  //     e.target.value
                                                  //   )
                                                  // }
                                                  disabled={getDisabledStatus}
                                                />
                                              </Col>
                                              <Col
                                                xs={12}
                                                md={4}
                                                lg={2}
                                                className="commTopButtonRightLeftPadding"
                                              >
                                                <InputField
                                                  className="inputBox"
                                                  type="date"
                                                  value={doc.issueDate}
                                                  // onChange={(e) =>
                                                  //   handleInputChange(
                                                  //     doc.id,
                                                  //     "issueDate",
                                                  //     e.target.value
                                                  //   )
                                                  // }
                                                  disabled={getDisabledStatus}
                                                />
                                              </Col>
                                              <Col
                                                xs={12}
                                                md={4}
                                                lg={1}
                                                className="commTopButtonRightLeftPadding"
                                              >
                                                <div className="d-flex justify-content-center">
                                                  {(doc.iSOCertification && (
                                                    <img
                                                      src="assets/img/newIcons/attached-file.png"
                                                      className="mt-1 attachmentIcon"
                                                      alt="attachments"
                                                      onClick={() =>
                                                        handleViewFile(
                                                          doc.iSOCertification
                                                        )
                                                      }
                                                    />
                                                  )) ||
                                                    "--"}
                                                </div>
                                              </Col>
                                              <Col
                                                xs={12}
                                                md={4}
                                                lg={3}
                                                className="commTopButtonRightLeftPadding"
                                              >
                                                <FileUploadComponent
                                                  id={doc.id}
                                                  name="iSOCertification"
                                                  label=""
                                                  allowedTypes={[
                                                    "image/png",
                                                    "image/jpeg",
                                                    "application/pdf",
                                                  ]}
                                                  multiple={true} // Change to `false` for single file selection
                                                  required={true}
                                                  onSuccessUpload={
                                                    onSuccessUploadDocumentType
                                                  }
                                                  value={
                                                    doc.iSOCertification || ""
                                                  }
                                                  disabled={getDisabledStatus}
                                                />
                                              </Col>
                                           
                                            </Row>
                                          )
                                        )}
                                      </div>
                                    </div>
                                  </Col>
                                </Row>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>

                {/* MOU/Agreement */}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible5
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility5}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">OI</span>
                        </Col>
                        <Col xs={8} md={9} lg={9}>
                          <span className="headerTitle">MOU/Agreement</span>
                          <span className="subHeaderTitle">
                            MOU/Agreement Details
                          </span>
                        </Col>
                      </Row>
                    </h2>

                    <div
                      className={`accordion-collapse collapse show ${
                        isCardVisible5 ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4">
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="MOU/LOI"
                              placeholder=""
                              // data={getmouLoi}
                              id="mouLoi"
                              iconClassName="dropdownIcon"
                              name="mouLoi"
                              code="countryCode"
                              description="countryDesc"
                              setValue={formInputs?.mouLoi}
                              getvalue={setDropdownData}
                              disabled={getDisabledStatus}
                              // error={validation?.mouLoi}
                            />
                            {formInputs?.mouLoi === "Yes" && (
                              <Row className="d-flex mt-2">
                                <Col xs={10} md={10} lg={10}>
                                  <FileUploadComponent
                                    id="mouLoiFile"
                                    name="mouLoiFile"
                                    label=""
                                    allowedTypes={[
                                      "image/png",
                                      "image/jpeg",
                                      "application/pdf",
                                    ]}
                                    multiple={true} // Change to false for single file selection
                                    // required={true}
                                    // onSuccessUpload={onSuccessUploadFile}
                                    value={formInputs?.mouLoiFile || ""}
                                    disabled={getDisabledStatus}
                                  />
                                </Col>
                                <Col xs={2} md={2} lg={2}>
                                  {(formInputs?.mouLoiFile && (
                                    <img
                                      src="assets/img/newIcons/attached-file.png"
                                      className="mt-1 attachmentIcon"
                                      alt="attachments"
                                      onClick={() =>
                                        handleViewFile(formInputs?.mouLoiFile)
                                      }
                                    />
                                  )) ||
                                    "--"}
                                </Col>
                              </Row>
                            )}
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Custodian Cheque"
                              placeholder=""
                              // data={getCustodianCheque}
                              id="custodianCheque"
                              iconClassName="dropdownIcon"
                              name="custodianCheque"
                              code="countryCode"
                              description="countryDesc"
                              setValue={formInputs?.custodianCheque}
                              getvalue={setDropdownData}
                              disabled={getDisabledStatus}
                              // error={validation?.custodianCheque}
                            />
                            {formInputs?.custodianCheque === "Yes" && (
                              <Row className="d-flex mt-2">
                                <Col xs={10} md={10} lg={10}>
                                  <FileUploadComponent
                                    id="custodianChequeFile"
                                    name="custodianChequeFile"
                                    label=""
                                    allowedTypes={[
                                      "image/png",
                                      "image/jpeg",
                                      "application/pdf",
                                    ]}
                                    multiple={true} // Change to false for single file selection
                                    // required={true}
                                    // onSuccessUpload={onSuccessUploadFile}
                                    value={
                                      formInputs?.custodianChequeFile || ""
                                    }
                                    disabled={getDisabledStatus}
                                  />
                                </Col>
                                <Col xs={2} md={2} lg={2}>
                                  {(formInputs?.custodianChequeFile && (
                                    <img
                                      src="assets/img/newIcons/attached-file.png"
                                      className="mt-1 attachmentIcon"
                                      alt="attachments"
                                      onClick={() =>
                                        handleViewFile(
                                          formInputs?.custodianChequeFile
                                        )
                                      }
                                    />
                                  )) ||
                                    "--"}
                                </Col>
                              </Row>
                            )}
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Signed Copy Received"
                              placeholder=""
                              // data={getSignedCopyReceived}
                              id="signedCopyReceived"
                              iconClassName="dropdownIcon"
                              name="signedCopyReceived"
                              code="countryCode"
                              description="countryDesc"
                              setValue={formInputs.signedCopyReceived}
                              getvalue={setDropdownData}
                              disabled={getDisabledStatus}
                              // error={validation.signedCopyReceived}
                            />
                            {formInputs?.signedCopyReceived === "Yes" && (
                              <Row className="d-flex mt-2">
                                <Col xs={10} md={10} lg={10}>
                                  <FileUploadComponent
                                    id="signedCopyReceivedFile"
                                    name="signedCopyReceivedFile"
                                    label=""
                                    allowedTypes={[
                                      "image/png",
                                      "image/jpeg",
                                      "application/pdf",
                                    ]}
                                    multiple={true} // Change to false for single file selection
                                    // required={true}
                                    // onSuccessUpload={onSuccessUploadFile}
                                    value={
                                      formInputs?.signedCopyReceivedFile || ""
                                    }
                                    disabled={getDisabledStatus}
                                  />
                                </Col>

                                <Col xs={2} md={2} lg={2}>
                                  {(formInputs?.signedCopyReceivedFile && (
                                    <img
                                      src="assets/img/newIcons/attached-file.png"
                                      className="mt-1 attachmentIcon"
                                      alt="attachments"
                                      onClick={() =>
                                        handleViewFile(
                                          formInputs?.signedCopyReceivedFile
                                        )
                                      }
                                    />
                                  )) ||
                                    "--"}
                                </Col>
                              </Row>
                            )}
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Agreement"
                              placeholder=""
                              // data={getAgreement}
                              id="agreement"
                              iconClassName="dropdownIcon"
                              name="agreement"
                              code="countryCode"
                              description="countryDesc"
                              setValue={formInputs.agreement}
                              getvalue={setDropdownData}
                              disabled={getDisabledStatus}
                              // error={validation.agreement}
                            />
                            {formInputs?.agreement === "Yes" && (
                              <Row className="d-flex mt-2">
                                <Col xs={10} md={10} lg={10}>
                                  <FileUploadComponent
                                    id="agreementFile"
                                    name="agreementFile"
                                    label=""
                                    allowedTypes={[
                                      "image/png",
                                      "image/jpeg",
                                      "application/pdf",
                                    ]}
                                    multiple={true} // Change to false for single file selection
                                    // required={true}
                                    // onSuccessUpload={onSuccessUploadFile}
                                    value={formInputs?.agreementFile || ""}
                                    disabled={getDisabledStatus}
                                  />
                                </Col>
                                <Col xs={2} md={2} lg={2}>
                                  {(formInputs?.agreementFile && (
                                    <img
                                      src="assets/img/newIcons/attached-file.png"
                                      className="mt-1 attachmentIcon"
                                      alt="attachments"
                                      onClick={() =>
                                        handleViewFile(
                                          formInputs?.agreementFile
                                        )
                                      }
                                    />
                                  )) ||
                                    "--"}
                                </Col>
                              </Row>
                            )}
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Bank Gurantee"
                              placeholder=""
                              // data={getBankGurantee}
                              id="bankGurantee"
                              iconClassName="dropdownIcon"
                              name="bankGurantee"
                              code="countryCode"
                              description="countryDesc"
                              setValue={formInputs?.bankGurantee}
                              getvalue={setDropdownData}
                              disabled={getDisabledStatus}
                              // error={validation?.bankGurantee}
                            />
                          </Col>
                          {formInputs?.bankGurantee === "Yes" && (
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Bank Gurantee Amt"
                                name="bankGuranteeAmt"
                                placeholder=""
                                value={formInputs?.bankGuranteeAmt || ""}
                                onChange={onInputChange}
                                disabled={getDisabledStatus}
                                // error={validation?.bankGuranteeAmt}
                              />
                            </Col>
                          )}
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Security Deposit"
                              placeholder=""
                              data={getSecurityDeposit}
                              id="securityDeposit"
                              iconClassName="dropdownIcon"
                              name="securityDeposit"
                              code="countryCode"
                              description="countryDesc"
                              setValue={formInputs?.securityDeposit}
                              getvalue={setDropdownData}
                              required={true}
                              disabled={getDisabledStatus}
                              // error={validation?.securityDeposit}
                            />
                          </Col>
                          {formInputs?.securityDeposit === "Yes" && (
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Security Deposit Amt"
                                name="securityDepositAmt"
                                placeholder=""
                                value={formInputs?.securityDepositAmt || ""}
                                onChange={onInputChange}
                                required={true}
                                disabled={getDisabledStatus}
                                // error={validation?.securityDepositAmt}
                              />
                            </Col>
                          )}
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Busniess Model  isCardVisible5*/}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible7
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility7}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">BM</span>
                        </Col>
                        <Col xs={12} md={9} lg={9}>
                          <span className="headerTitle">Busniess Model</span>
                          <span className="subHeaderTitle">
                            Busniess Model Details
                          </span>
                        </Col>

                        <Col xs={2} md={1} lg={1} className="">
                          <CommonFillter />
                        </Col>
                      </Row>
                    </h2>

                    <div
                      className={`accordion-collapse collapse show ${
                        isCardVisible7 ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4">
                          {(!isExclusiveKeys1True ||
                            formInputs?.consignment) && (
                            <Col
                              xs={12}
                              md={3}
                              lg={3}
                              className="commTopButtonRightLeftPadding d-flex"
                            >
                              <div>
                                <label
                                  className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer cursor-pointer me-2"
                                  htmlFor="consignment"
                                >
                                  Consignment
                                </label>
                              </div>
                              <div className="form-check form-switch">
                                <input
                                  className="form-check-input custom-switch"
                                  type="checkbox"
                                  role="switch"
                                  name="consignment"
                                  id="consignment"
                                  checked={formInputs?.consignment === true}
                                  onChange={checkBoxChange}
                                  disabled={nonInvitedDisable}
                                />
                                <span>
                                  {formInputs?.consignment === true
                                    ? "Yes"
                                    : "No"}
                                </span>
                              </div>
                            </Col>
                          )}

                          {(!isExclusiveKeys1True ||
                            formInputs.saleorReturn) && (
                            <Col
                              xs={12}
                              md={3}
                              lg={3}
                              className="commTopButtonRightLeftPadding d-flex"
                            >
                              <div>
                                <label
                                  className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                  htmlFor="saleorReturn"
                                >
                                  Sale or Return
                                </label>
                              </div>
                              <div className="form-check form-switch">
                                <input
                                  className="form-check-input custom-switch"
                                  type="checkbox"
                                  role="switch"
                                  name="saleorReturn"
                                  id="saleorReturn"
                                  checked={formInputs?.saleorReturn === true}
                                  onChange={checkBoxChange}
                                  disabled={nonInvitedDisable}
                                />
                                <span>
                                  {formInputs?.saleorReturn === true
                                    ? "Yes"
                                    : "No"}
                                </span>
                              </div>
                            </Col>
                          )}
                          {(!isExclusiveKeys1True || formInputs.outright) && (
                            <Col
                              xs={12}
                              md={3}
                              lg={3}
                              className="commTopButtonRightLeftPadding d-flex"
                            >
                              <div>
                                <label
                                  className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                  htmlFor="outright"
                                >
                                  Outright
                                </label>
                              </div>
                              <div className="form-check form-switch">
                                <input
                                  className="form-check-input custom-switch"
                                  type="checkbox"
                                  role="switch"
                                  name="outright"
                                  id="outright"
                                  checked={formInputs?.outright === true}
                                  onChange={checkBoxChange}
                                  disabled={nonInvitedDisable}
                                />
                                <span>
                                  {formInputs?.outright === true ? "Yes" : "No"}
                                </span>
                              </div>
                            </Col>
                          )}
                          {(!isExclusiveKeys1True ||
                            formInputs.interCompany) && (
                            <Col
                              xs={12}
                              md={3}
                              lg={3}
                              className="commTopButtonRightLeftPadding d-flex"
                            >
                              <div>
                                <label
                                  className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                  htmlFor="interCompany"
                                >
                                  Inter Company
                                </label>
                              </div>
                              <div className="form-check form-switch">
                                <input
                                  className="form-check-input custom-switch"
                                  type="checkbox"
                                  role="switch"
                                  name="interCompany"
                                  id="interCompany"
                                  checked={formInputs?.interCompany === true}
                                  onChange={checkBoxChange}
                                  disabled={nonInvitedDisable}
                                />
                                <span>
                                  {formInputs?.interCompany === true
                                    ? "Yes"
                                    : "No"}
                                </span>
                              </div>
                            </Col>
                          )}
                          {(!isExclusiveKeys1True || formInputs.warehouse) && (
                            <Col
                              xs={12}
                              md={3}
                              lg={3}
                              className="commTopButtonRightLeftPadding d-flex"
                            >
                              <div>
                                <label
                                  className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                  htmlFor="warehouse"
                                >
                                  Warehouse
                                </label>
                              </div>
                              <div className="form-check form-switch">
                                <input
                                  className="form-check-input custom-switch"
                                  type="checkbox"
                                  role="switch"
                                  name="warehouse"
                                  id="warehouse"
                                  checked={formInputs?.warehouse === true}
                                  onChange={checkBoxChange}
                                  disabled={nonInvitedDisable}
                                />
                                <span>
                                  {formInputs?.warehouse === true
                                    ? "Yes"
                                    : "No"}
                                </span>
                              </div>
                            </Col>
                          )}
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
                {/* company Code  isCardVisible5*/}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible6
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility6}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">CC</span>
                        </Col>
                        <Col xs={12} md={9} lg={9}>
                          <span className="headerTitle">Company Code</span>
                          <span className="subHeaderTitle">
                            Code of the Company
                          </span>
                        </Col>

                        <Col xs={2} md={1} lg={1} className="">
                          <CommonFillter />
                        </Col>
                      </Row>
                    </h2>

                    <div
                      className={`accordion-collapse collapse show ${
                        isCardVisible6 ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4">
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding d-flex"
                          >
                            <div>
                              <label
                                className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer cursor-pointer me-2"
                                htmlFor="arvindLifestyle"
                              >
                                Arvind Lifestyle Brands Limited
                              </label>
                            </div>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input custom-switch"
                                type="checkbox"
                                role="switch"
                                name="arvindLifestyle"
                                id="arvindLifestyle"
                                checked={formInputs?.arvindLifestyle === true}
                                onChange={onInputChange}
                                disabled={nonInvitedDisable}
                              />
                              <span>
                                {formInputs?.arvindLifestyle === true
                                  ? "Yes"
                                  : "No"}
                              </span>
                            </div>
                          </Col>
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding d-flex"
                          >
                            <div>
                              <label
                                className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                htmlFor="flyingmachineOptions"
                              >
                                Arvind Fashions Limited
                              </label>
                            </div>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input custom-switch"
                                type="checkbox"
                                role="switch"
                                name="flyingmachineOptions"
                                id="flyingmachineOptions"
                                checked={
                                  formInputs?.flyingmachineOptions === true
                                }
                                onChange={onInputChange}
                                disabled={nonInvitedDisable}
                              />
                              <span>
                                {formInputs?.flyingmachineOptions === true
                                  ? "Yes"
                                  : "No"}
                              </span>
                            </div>
                          </Col>

                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding d-flex"
                          >
                            <div>
                              <label
                                className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                htmlFor="arvindYouthBrands"
                              >
                                Arvind Youth Brands Private Ltd
                              </label>
                            </div>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input custom-switch"
                                type="checkbox"
                                role="switch"
                                name="arvindYouthBrands"
                                id="arvindYouthBrands"
                                checked={formInputs?.arvindYouthBrands === true}
                                onChange={onInputChange}
                                disabled={nonInvitedDisable}
                              />
                              <span>
                                {formInputs?.arvindYouthBrands === true
                                  ? "Yes"
                                  : "No"}
                              </span>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
                {/* channel isCardVisible5*/}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible8
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility8}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">C</span>
                        </Col>
                        <Col xs={12} md={9} lg={9}>
                          <span className="headerTitle">Channel</span>
                          <span className="subHeaderTitle">
                            Channel Details
                          </span>
                        </Col>

                        <Col xs={2} md={1} lg={1} className="">
                          <CommonFillter />
                        </Col>
                      </Row>
                    </h2>

                    <div
                      className={`accordion-collapse collapse show ${
                        isCardVisible8 ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4">
                          {(!isExclusiveKeys2True ||
                            formInputs?.exclusiveBrandOutlet) && (
                            <Col
                              xs={12}
                              md={3}
                              lg={3}
                              className="commTopButtonRightLeftPadding d-flex"
                            >
                              <div>
                                <label
                                  className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer cursor-pointer me-2"
                                  htmlFor="exclusiveBrandOutlet"
                                >
                                  Exclusive Brand Outlet
                                </label>
                              </div>
                              <div className="form-check form-switch">
                                <input
                                  className="form-check-input custom-switch"
                                  type="checkbox"
                                  role="switch"
                                  name="exclusiveBrandOutlet"
                                  id="exclusiveBrandOutlet"
                                  checked={
                                    formInputs?.exclusiveBrandOutlet === true
                                  }
                                  onChange={onInputChange}
                                  disabled={nonInvitedDisable}
                                />
                                <span>
                                  {formInputs?.exclusiveBrandOutlet === true
                                    ? "Yes"
                                    : "No"}
                                </span>
                              </div>
                            </Col>
                          )}
                          {(!isExclusiveKeys2True ||
                            formInputs?.multiBrandOutlet) && (
                            <Col
                              xs={12}
                              md={3}
                              lg={3}
                              className="commTopButtonRightLeftPadding d-flex"
                            >
                              <div>
                                <label
                                  className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                  htmlFor="multiBrandOutlet"
                                >
                                  Multi Brand Outlet
                                </label>
                              </div>
                              <div className="form-check form-switch">
                                <input
                                  className="form-check-input custom-switch"
                                  type="checkbox"
                                  role="switch"
                                  name="multiBrandOutlet"
                                  id="multiBrandOutlet"
                                  checked={
                                    formInputs?.multiBrandOutlet === true
                                  }
                                  onChange={onInputChange}
                                  disabled={nonInvitedDisable}
                                />
                                <span>
                                  {formInputs?.multiBrandOutlet === true
                                    ? "Yes"
                                    : "No"}
                                </span>
                              </div>
                            </Col>
                          )}
                          {(!isExclusiveKeys2True ||
                            formInputs?.keyAccounts) && (
                            <Col
                              xs={12}
                              md={3}
                              lg={3}
                              className="commTopButtonRightLeftPadding d-flex"
                            >
                              <div>
                                <label
                                  className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                  htmlFor="keyAccounts"
                                >
                                  Key Accounts
                                </label>
                              </div>
                              <div className="form-check form-switch">
                                <input
                                  className="form-check-input custom-switch"
                                  type="checkbox"
                                  role="switch"
                                  name="keyAccounts"
                                  id="keyAccounts"
                                  checked={formInputs?.keyAccounts === true}
                                  onChange={onInputChange}
                                  disabled={nonInvitedDisable}
                                />
                                <span>
                                  {formInputs?.keyAccounts === true
                                    ? "Yes"
                                    : "No"}
                                </span>
                              </div>
                            </Col>
                          )}
                          {(!isExclusiveKeys2True ||
                            formInputs?.keyAccounts) && (
                            <Col
                              xs={12}
                              md={3}
                              lg={3}
                              className="commTopButtonRightLeftPadding d-flex"
                            >
                              <div>
                                <label
                                  className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                  htmlFor="online"
                                >
                                  Online
                                </label>
                              </div>
                              <div className="form-check form-switch">
                                <input
                                  className="form-check-input custom-switch"
                                  type="checkbox"
                                  role="switch"
                                  name="online"
                                  id="online"
                                  checked={formInputs?.online === true}
                                  onChange={onInputChange}
                                  disabled={nonInvitedDisable}
                                />
                                <span>
                                  {formInputs?.online === true ? "Yes" : "No"}
                                </span>
                              </div>
                            </Col>
                          )}
                          {(!isExclusiveKeys2True ||
                            formInputs?.liquidation) && (
                            <Col
                              xs={12}
                              md={3}
                              lg={3}
                              className="commTopButtonRightLeftPadding d-flex"
                            >
                              <div>
                                <label
                                  className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                  htmlFor="liquidation"
                                >
                                  Liquidation
                                </label>
                              </div>
                              <div className="form-check form-switch">
                                <input
                                  className="form-check-input custom-switch"
                                  type="checkbox"
                                  role="switch"
                                  name="liquidation"
                                  id="liquidation"
                                  checked={formInputs?.liquidation === true}
                                  onChange={onInputChange}
                                  disabled={nonInvitedDisable}
                                />
                                <span>
                                  {formInputs?.liquidation === true
                                    ? "Yes"
                                    : "No"}
                                </span>
                              </div>
                            </Col>
                          )}
                          {(!isExclusiveKeys2True ||
                            formInputs?.institutional) && (
                            <Col
                              xs={12}
                              md={3}
                              lg={3}
                              className="commTopButtonRightLeftPadding d-flex"
                            >
                              <div>
                                <label
                                  className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                  htmlFor="institutional"
                                >
                                  Institutional
                                </label>
                              </div>
                              <div className="form-check form-switch">
                                <input
                                  className="form-check-input custom-switch"
                                  type="checkbox"
                                  role="switch"
                                  name="institutional"
                                  id="institutional"
                                  checked={formInputs?.institutional === true}
                                  onChange={onInputChange}
                                  disabled={nonInvitedDisable}
                                />
                                <span>
                                  {formInputs?.institutional === true
                                    ? "Yes"
                                    : "No"}
                                </span>
                              </div>
                            </Col>
                          )}
                          {(!isExclusiveKeys2True || formInputs?.export) && (
                            <Col
                              xs={12}
                              md={3}
                              lg={3}
                              className="commTopButtonRightLeftPadding d-flex"
                            >
                              <div>
                                <label
                                  className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                  htmlFor="export"
                                >
                                  Export
                                </label>
                              </div>
                              <div className="form-check form-switch">
                                <input
                                  className="form-check-input custom-switch"
                                  type="checkbox"
                                  role="switch"
                                  name="export"
                                  id="export"
                                  checked={formInputs?.export === true}
                                  onChange={onInputChange}
                                  disabled={nonInvitedDisable}
                                />
                                <span>
                                  {formInputs?.export === true ? "Yes" : "No"}
                                </span>
                              </div>
                            </Col>
                          )}
                          {(!isExclusiveKeys2True ||
                            formInputs?.marketPlace) && (
                            <Col
                              xs={12}
                              md={3}
                              lg={3}
                              className="commTopButtonRightLeftPadding d-flex"
                            >
                              <div>
                                <label
                                  className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                  htmlFor="marketPlace"
                                >
                                  Market Place
                                </label>
                              </div>
                              <div className="form-check form-switch">
                                <input
                                  className="form-check-input custom-switch"
                                  type="checkbox"
                                  role="switch"
                                  name="marketPlace"
                                  id="marketPlace"
                                  checked={formInputs?.marketPlace === true}
                                  onChange={onInputChange}
                                  disabled={nonInvitedDisable}
                                />
                                <span>
                                  {formInputs?.marketPlace === true
                                    ? "Yes"
                                    : "No"}
                                </span>
                              </div>
                            </Col>
                          )}
                          {(!isExclusiveKeys2True ||
                            formInputs?.commonChannel) && (
                            <Col
                              xs={12}
                              md={3}
                              lg={3}
                              className="commTopButtonRightLeftPadding d-flex"
                            >
                              <div>
                                <label
                                  className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                  htmlFor="commonChannel"
                                >
                                  Common Channel
                                </label>
                              </div>
                              <div className="form-check form-switch">
                                <input
                                  className="form-check-input custom-switch"
                                  type="checkbox"
                                  role="switch"
                                  name="commonChannel"
                                  id="commonChannel"
                                  checked={formInputs?.commonChannel === true}
                                  onChange={onInputChange}
                                  disabled={nonInvitedDisable}
                                />
                                <span>
                                  {formInputs?.commonChannel === true
                                    ? "Yes"
                                    : "No"}
                                </span>
                              </div>
                            </Col>
                          )}
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Margin Details isCardVisible5*/}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible9
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility9}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">MD</span>
                        </Col>
                        <Col xs={12} md={9} lg={9}>
                          <span className="headerTitle">Margin Details</span>
                          <span className="subHeaderTitle">
                            Margin Details Details
                          </span>
                        </Col>

                        <Col xs={2} md={1} lg={1} className="">
                          <CommonFillter />
                        </Col>
                      </Row>
                    </h2>

                    <div
                      className={`accordion-collapse collapse show ${
                        isCardVisible9 ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4">
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding d-flex"
                          >
                            <div>
                              <label
                                className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer cursor-pointer me-2"
                                htmlFor="y007BaseMargin"
                              >
                                Base Margin
                              </label>
                            </div>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input custom-switch"
                                type="checkbox"
                                role="switch"
                                name="y007BaseMargin"
                                id="y007BaseMargin"
                                checked={formInputs?.y007BaseMargin === true}
                                onChange={onInputChange}
                                disabled={nonInvitedDisable}
                              />
                              <span>
                                {formInputs?.y007BaseMargin === true
                                  ? "Yes"
                                  : "No"}
                              </span>
                            </div>
                          </Col>
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding d-flex"
                          >
                            <div>
                              <label
                                className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                htmlFor="y014SpecialMargin"
                              >
                                Special Margin
                              </label>
                            </div>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input custom-switch"
                                type="checkbox"
                                role="switch"
                                name="y014SpecialMargin"
                                id="y014SpecialMargin"
                                checked={formInputs?.y014SpecialMargin === true}
                                onChange={onInputChange}
                                disabled={nonInvitedDisable}
                              />
                              <span>
                                {formInputs?.y014SpecialMargin === true
                                  ? "Yes"
                                  : "No"}
                              </span>
                            </div>
                          </Col>
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding d-flex"
                          >
                            <div>
                              <label
                                className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                htmlFor="y003SpecialMargin"
                              >
                                Special Margin
                              </label>
                            </div>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input custom-switch"
                                type="checkbox"
                                role="switch"
                                name="y003SpecialMargin"
                                id="y003SpecialMargin"
                                checked={formInputs?.y003SpecialMargin === true}
                                onChange={onInputChange}
                                disabled={nonInvitedDisable}
                              />
                              <span>
                                {formInputs?.y003SpecialMargin === true
                                  ? "Yes"
                                  : "No"}
                              </span>
                            </div>
                          </Col>
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding d-flex"
                          >
                            <div>
                              <label
                                className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                htmlFor="yS60STOMargin"
                              >
                                STO Margin
                              </label>
                            </div>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input custom-switch"
                                type="checkbox"
                                role="switch"
                                name="yS60STOMargin"
                                id="yS60STOMargin"
                                checked={formInputs?.yS60STOMargin === true}
                                onChange={onInputChange}
                                disabled={nonInvitedDisable}
                              />
                              <span>
                                {formInputs?.yS60STOMargin === true
                                  ? "Yes"
                                  : "No"}
                              </span>
                            </div>
                          </Col>
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding d-flex"
                          >
                            <div>
                              <label
                                className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                htmlFor="y003ScaleWise"
                              >
                                Scale Wise
                              </label>
                            </div>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input custom-switch"
                                type="checkbox"
                                role="switch"
                                name="y003ScaleWise"
                                id="y003ScaleWise"
                                checked={formInputs?.y003ScaleWise === true}
                                onChange={onInputChange}
                                disabled={nonInvitedDisable}
                              />
                              <span>
                                {formInputs?.y003ScaleWise === true
                                  ? "Yes"
                                  : "No"}
                              </span>
                            </div>
                          </Col>
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding d-flex"
                          >
                            <div>
                              <label
                                className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                htmlFor="y010DealerMargin"
                              >
                                Dealer Margin
                              </label>
                            </div>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input custom-switch"
                                type="checkbox"
                                role="switch"
                                name="y010DealerMargin"
                                id="y010DealerMargin"
                                checked={formInputs?.y010DealerMargin === true}
                                onChange={onInputChange}
                                disabled={nonInvitedDisable}
                              />
                              <span>
                                {formInputs?.y010DealerMargin === true
                                  ? "Yes"
                                  : "No"}
                              </span>
                            </div>
                          </Col>
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding d-flex"
                          >
                            <div>
                              <label
                                className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                htmlFor="marginNotProvided"
                              >
                                If Margin not Provided, Kindly share the Format
                              </label>
                            </div>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input custom-switch"
                                type="checkbox"
                                role="switch"
                                name="marginNotProvided"
                                id="marginNotProvided"
                                checked={formInputs?.marginNotProvided === true}
                                onChange={onInputChange}
                                disabled={nonInvitedDisable}
                              />
                              <span>
                                {formInputs?.marginNotProvided === true
                                  ? "Yes"
                                  : "No"}
                              </span>
                            </div>
                          </Col>
                          {formInputs?.marginNotProvided && (
                            <>
                              <Col
                                xs={12}
                                md={3}
                                lg={3}
                                className="commTopButtonRightLeftPadding d-flex"
                              >
                                <div>
                                  <label
                                    className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                    htmlFor="y007Y014Y003Y010YS60"
                                  >
                                    Y007,Y014,Y003,Y010,YS60
                                  </label>
                                </div>
                                <div className="form-check form-switch">
                                  <input
                                    className="form-check-input custom-switch"
                                    type="checkbox"
                                    role="switch"
                                    name="y007Y014Y003Y010YS60"
                                    id="y007Y014Y003Y010YS60"
                                    checked={
                                      formInputs?.y007Y014Y003Y010YS60 === true
                                    }
                                    onChange={onInputChange}
                                    disabled={nonInvitedDisable}
                                  />
                                  <span>
                                    {formInputs?.y007Y014Y003Y010YS60 === true
                                      ? "Yes"
                                      : "No"}
                                  </span>
                                </div>
                              </Col>
                              <Col
                                xs={12}
                                md={3}
                                lg={3}
                                className="commTopButtonRightLeftPadding d-flex"
                              >
                                <div>
                                  <label
                                    className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                    htmlFor="y003scaleWise"
                                  >
                                    Scale Wise
                                  </label>
                                </div>
                                <div className="form-check form-switch">
                                  <input
                                    className="form-check-input custom-switch"
                                    type="checkbox"
                                    role="switch"
                                    name="y003scaleWise"
                                    id="y003scaleWise"
                                    checked={formInputs?.y003scaleWise === true}
                                    onChange={onInputChange}
                                    disabled={nonInvitedDisable}
                                  />
                                  <span>
                                    {formInputs?.y003scaleWise === true
                                      ? "Yes"
                                      : "No"}
                                  </span>
                                </div>
                              </Col>
                              <Col
                                xs={12}
                                md={3}
                                lg={3}
                                className="commTopButtonRightLeftPadding d-flex"
                              >
                                <div>
                                  <label
                                    className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                    htmlFor="articleBasedPricing"
                                  >
                                    Article Based Pricing
                                  </label>
                                </div>
                                <div className="form-check form-switch">
                                  <input
                                    className="form-check-input custom-switch"
                                    type="checkbox"
                                    role="switch"
                                    name="articleBasedPricing"
                                    id="articleBasedPricing"
                                    checked={
                                      formInputs?.articleBasedPricing === true
                                    }
                                    onChange={onInputChange}
                                    disabled={nonInvitedDisable}
                                  />
                                  <span>
                                    {formInputs?.articleBasedPricing === true
                                      ? "Yes"
                                      : "No"}
                                  </span>
                                </div>
                              </Col>
                            </>
                          )}
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Brand Division  isCardVisible5*/}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible10
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility10}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">BD</span>
                        </Col>
                        <Col xs={12} md={9} lg={9}>
                          <span className="headerTitle">Brand Division</span>
                          <span className="subHeaderTitle">Brand Division</span>
                        </Col>

                        <Col xs={2} md={1} lg={1}>
                          <CommonFillter />
                        </Col>
                      </Row>
                    </h2>

                    <div
                      className={`accordion-collapse collapse show ${
                        isCardVisible10 ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4">
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding d-flex"
                          >
                            <div>
                              <label
                                className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                htmlFor="uSPolo"
                              >
                                U.S. Polo
                              </label>
                            </div>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input custom-switch"
                                type="checkbox"
                                role="switch"
                                name="uSPolo"
                                id="uSPolo"
                                checked={formInputs?.uSPolo === true}
                                onChange={onInputChange}
                                disabled={nonInvitedDisable}
                              />
                              <span>
                                {formInputs?.uSPolo === true ? "Yes" : "No"}
                              </span>
                            </div>
                          </Col>
                          {formInputs?.uSPolo && (
                            <Col
                              xs={12}
                              md={3}
                              lg={3}
                              className="commTopButtonRightLeftPadding d-flex"
                            >
                              <div>
                                <label
                                  className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                  htmlFor="uSPoloFootwear"
                                >
                                  U.S Polo Footwear
                                </label>
                              </div>
                              <div className="form-check form-switch">
                                <input
                                  className="form-check-input custom-switch"
                                  type="checkbox"
                                  role="switch"
                                  name="uSPoloFootwear"
                                  id="uSPoloFootwear"
                                  checked={formInputs?.uSPoloFootwear === true}
                                  onChange={onInputChange}
                                  disabled={nonInvitedDisable}
                                />
                                <span>
                                  {formInputs?.uSPoloFootwear === true
                                    ? "Yes"
                                    : "No"}
                                </span>
                              </div>
                            </Col>
                          )}

                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding d-flex"
                          >
                            <div>
                              <label
                                className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                htmlFor="arrow"
                              >
                                Arrow
                              </label>
                            </div>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input custom-switch"
                                type="checkbox"
                                role="switch"
                                name="arrow"
                                id="arrow"
                                checked={formInputs?.arrow === true}
                                onChange={onInputChange}
                                disabled={nonInvitedDisable}
                              />
                              <span>
                                {formInputs?.arrow === true ? "Yes" : "No"}
                              </span>
                            </div>
                          </Col>
                          {formInputs?.arrow && (
                            <Col
                              xs={12}
                              md={3}
                              lg={3}
                              className="commTopButtonRightLeftPadding d-flex"
                            >
                              <div>
                                <label
                                  className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                  htmlFor="arrowFootwear"
                                >
                                  Arrow Footwear
                                </label>
                              </div>
                              <div className="form-check form-switch">
                                <input
                                  className="form-check-input custom-switch"
                                  type="checkbox"
                                  role="switch"
                                  name="arrowFootwear"
                                  id="arrowFootwear"
                                  checked={formInputs?.arrowFootwear === true}
                                  onChange={onInputChange}
                                  disabled={nonInvitedDisable}
                                />
                                <span>
                                  {formInputs?.arrowFootwear === true
                                    ? "Yes"
                                    : "No"}
                                </span>
                              </div>
                            </Col>
                          )}
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding d-flex"
                          >
                            <div>
                              <label
                                className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                htmlFor="flyingMachine"
                              >
                                Flying Machine
                              </label>
                            </div>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input custom-switch"
                                type="checkbox"
                                role="switch"
                                name="flyingMachine"
                                id="flyingMachine"
                                checked={formInputs?.flyingMachine === true}
                                onChange={onInputChange}
                                disabled={nonInvitedDisable}
                              />
                              <span>
                                {formInputs?.flyingMachine === true
                                  ? "Yes"
                                  : "No"}
                              </span>
                            </div>
                          </Col>
                          {formInputs?.flyingMachine && (
                            <Col
                              xs={12}
                              md={3}
                              lg={3}
                              className="commTopButtonRightLeftPadding d-flex"
                            >
                              <div>
                                <label
                                  className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                  htmlFor="flyingMachineFootwear"
                                >
                                  Flying Machine Footwear
                                </label>
                              </div>
                              <div className="form-check form-switch">
                                <input
                                  className="form-check-input custom-switch"
                                  type="checkbox"
                                  role="switch"
                                  name="flyingMachineFootwear"
                                  id="flyingMachineFootwear"
                                  checked={
                                    formInputs?.flyingMachineFootwear === true
                                  }
                                  onChange={onInputChange}
                                  disabled={nonInvitedDisable}
                                />
                                <span>
                                  {formInputs?.flyingMachineFootwear === true
                                    ? "Yes"
                                    : "No"}
                                </span>
                              </div>
                            </Col>
                          )}
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding d-flex"
                          >
                            <div>
                              <label
                                className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                htmlFor="calvinKelvin"
                              >
                                Calvin Kelvin
                              </label>
                            </div>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input custom-switch"
                                type="checkbox"
                                role="switch"
                                name="calvinKelvin"
                                id="calvinKelvin"
                                checked={formInputs?.calvinKelvin === true}
                                onChange={onInputChange}
                                disabled={nonInvitedDisable}
                              />
                              <span>
                                {formInputs?.calvinKelvin === true
                                  ? "Yes"
                                  : "No"}
                              </span>
                            </div>
                          </Col>
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding d-flex"
                          >
                            <div>
                              <label
                                className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                htmlFor="tommyHilfiger"
                              >
                                Tommy Hilfiger
                              </label>
                            </div>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input custom-switch"
                                type="checkbox"
                                role="switch"
                                name="tommyHilfiger"
                                id="tommyHilfiger"
                                checked={formInputs?.tommyHilfiger === true}
                                onChange={onInputChange}
                                disabled={nonInvitedDisable}
                              />
                              <span>
                                {formInputs?.tommyHilfiger === true
                                  ? "Yes"
                                  : "No"}
                              </span>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Other Details  isCardVisible5*/}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible11
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility11}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">OD</span>
                        </Col>
                        <Col xs={12} md={9} lg={9}>
                          <span className="headerTitle">Other Details</span>
                          <span className="subHeaderTitle">Other Details</span>
                        </Col>

                        <Col xs={2} md={1} lg={1}>
                          <CommonFillter />
                        </Col>
                      </Row>
                    </h2>

                    <div
                      className={`accordion-collapse collapse show ${
                        isCardVisible11 ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4">
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding d-flex"
                          >
                            <div>
                              <label
                                className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                htmlFor="otherDetails"
                              >
                                Other Details
                              </label>
                            </div>
                            <div className="form-check">
                              <input
                                className="form-check-input custom-switch"
                                type="checkbox"
                                role="switch"
                                name="otherDetails"
                                id="otherDetails"
                                checked={formInputs?.otherDetails === true}
                                onChange={onInputChange}
                                disabled={nonInvitedDisable}
                              />
                            </div>
                          </Col>
                          {formInputs?.otherDetails && (
                            <Row>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <ComboboxField
                                  label="Customer group"
                                  placeholder=""
                                  data={getCustomergroup}
                                  id="customergroup"
                                  iconClassName="dropdownIcon"
                                  name="customergroup"
                                  code="countryCode"
                                  description="countryDesc"
                                  setValue={formInputs?.customergroup}
                                  getvalue={setDropdownData}
                                  disabled={nonInvitedDisable}
                                  // required={true}
                                  // error={validation.customergroup}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Customer Name"
                                  name="organisationName"
                                  placeholder=""
                                  value={formInputs?.organisationName || ""}
                                  onChange={onInputChange}
                                  disabled={nonInvitedDisable}
                                  // required={true}
                                  // error={validation.organisationName}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Delivery Plant"
                                  extraLabel="if blank deliver pant will be considered as 7000 (2100),9000(2560) & 8000 (2500)"
                                  name="deliveryPlant"
                                  placeholder=""
                                  value={formInputs?.deliveryPlant || ""}
                                  onChange={onInputChange}
                                  disabled={nonInvitedDisable}
                                  // required={true}
                                  // error={validation.deliveryPlant}
                                />
                              </Col>
                            </Row>
                          )}
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>

                {(formInputs?.consignment || formInputs?.saleorReturn) && (
                  <>
                    {/* Applicable for SOR/CONSIGNMENT Model isCardVisible5*/}
                    <div className="accordion mb-4" id="accordionExample">
                      <div className="accordion-item">
                        <h2 className="accordion-header">
                          <Row className="accordion-button">
                            <Col
                              xs={1}
                              md={1}
                              lg={1}
                              className="text-left arrowBtn"
                            >
                              <i
                                className={`bi ${
                                  isCardVisible5
                                    ? "bi-chevron-right"
                                    : "bi-chevron-down"
                                }`}
                                onClick={toggleCardVisibility5}
                              ></i>
                            </Col>
                            <Col
                              xs={1}
                              md={1}
                              lg={1}
                              className="text-center logoBtn"
                            >
                              <span className="iconLogo">OD</span>
                            </Col>
                            <Col xs={12} md={9} lg={9}>
                              <span className="headerTitle">
                                Applicable for SOR/CONSIGNMENT Model
                              </span>
                              <span className="subHeaderTitle">
                                Applicable for SOR/CONSIGNMENT Model Details
                              </span>
                            </Col>

                            <Col xs={2} md={1} lg={1}>
                              <CommonFillter />
                            </Col>
                          </Row>
                        </h2>

                        <div
                          className={`accordion-collapse collapse show ${
                            isCardVisible5 ? "visible" : ""
                          }`}
                        >
                          <div className="accordion-body">
                            <Row>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <ComboboxField
                                  label="Store City Tire"
                                  placeholder=""
                                  data={getstoreCityTire}
                                  id="storeCityTire"
                                  iconClassName="dropdownIcon"
                                  name="storeCityTire"
                                  // code="storeCityTireCode"
                                  description="countryDesc"
                                  setValue={formInputs?.storeCityTire}
                                  getvalue={setDropdownData}
                                  disabled={nonInvitedDisable}
                                  // required={true}
                                  // error={validation.storeCityTire}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding d-flex align-items-center"
                              >
                                <div>
                                  <label
                                    className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                    htmlFor="multipleBrands"
                                  >
                                    Multiple Brands
                                  </label>
                                </div>
                                <div className="form-check form-switch">
                                  <input
                                    className="form-check-input custom-switch"
                                    type="checkbox"
                                    role="switch"
                                    name="multipleBrands"
                                    id="multipleBrands"
                                    checked={
                                      formInputs?.multipleBrands === true
                                    }
                                    onChange={onInputChange}
                                    disabled={nonInvitedDisable}
                                  />
                                  <span>
                                    {formInputs?.multipleBrands === true
                                      ? "Yes"
                                      : "No"}
                                  </span>
                                </div>
                              </Col>

                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <ComboboxField
                                  label="Customer Group"
                                  placeholder=""
                                  data={getCustomerGroup}
                                  id="customerGroup"
                                  iconClassName="dropdownIcon"
                                  name="customerGroup"
                                  // code="customerGroupCode"
                                  // description="customerGroupDesc"
                                  setValue={formInputs?.customerGroup}
                                  getvalue={setDropdownData}
                                  disabled={nonInvitedDisable}
                                  // required={true}
                                  // error={validation.customerGroup}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <ComboboxField
                                  label="Store Type"
                                  placeholder=""
                                  data={getStoreType}
                                  id="storeType"
                                  iconClassName="dropdownIcon"
                                  name="storeType"
                                  // code="storeTypeCode"
                                  // description="storeTypeDesc"
                                  setValue={formInputs?.storeType}
                                  getvalue={setDropdownData}
                                  disabled={nonInvitedDisable}
                                  // required={true}
                                  // error={validation.storeType}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <ComboboxField
                                  label="City Classification"
                                  placeholder=""
                                  data={getStoreType}
                                  id="cityClassification"
                                  iconClassName="dropdownIcon"
                                  name="cityClassification"
                                  // code="cityClassificationCode"
                                  // description="cityClassificationDesc"
                                  setValue={formInputs?.cityClassification}
                                  getvalue={setDropdownData}
                                  disabled={nonInvitedDisable}
                                  // required={true}
                                  // error={validation.cityClassification}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <ComboboxField
                                  label="Rental Type"
                                  placeholder=""
                                  data={getRentalType}
                                  id="rentalType"
                                  iconClassName="dropdownIcon"
                                  name="rentalType"
                                  // code="rentalTypeCode"
                                  // description="rentalTypeDesc"
                                  setValue={formInputs?.rentalType}
                                  getvalue={setDropdownData}
                                  disabled={nonInvitedDisable}
                                  // required={true}
                                  // error={validation.rentalType}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <ComboboxField
                                  label="Ownership Type"
                                  placeholder=""
                                  data={getOwnershipType}
                                  id="ownershipType"
                                  iconClassName="dropdownIcon"
                                  name="ownershipType"
                                  // code="ownershipTypeCode"
                                  // description="ownershipTypeDesc"
                                  setValue={formInputs?.ownershipType}
                                  getvalue={setDropdownData}
                                  disabled={nonInvitedDisable}
                                  // required={true}
                                  // error={validation.ownershipType}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <ComboboxField
                                  label="Brand Division Attribute"
                                  placeholder=""
                                  data={getBrandDivisionAttribute}
                                  id="brandDivisionAttribute"
                                  iconClassName="dropdownIcon"
                                  name="brandDivisionAttribute"
                                  // code="brandDivisionAttributeCode"
                                  // description="brandDivisionAttributeDesc"
                                  setValue={formInputs?.brandDivisionAttribute}
                                  getvalue={setDropdownData}
                                  disabled={nonInvitedDisable}
                                  // required={true}
                                  // error={validation.brandDivisionAttribute}
                                />
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </>
            )}

            {(formInputs.status === "In Registration" ||
              formInputs.status === "Invited" ||
              formInputs.status === "Registered") && <></>}

            {getRole === "MDM" && (
              <>
                {/* Sold to Party */}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible12
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility12}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">SP</span>
                        </Col>
                        <Col xs={12} md={9} lg={9}>
                          <span className="headerTitle">Sold To Party</span>
                          <span className="subHeaderTitle">
                            Sold To Party Details
                          </span>
                        </Col>

                        <Col xs={2} md={1} lg={1} className="">
                          <CommonFillter />
                        </Col>
                      </Row>
                    </h2>

                    <div
                      className={`accordion-collapse collapse show ${
                        isCardVisible12 ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4">
                          <Col
                            xs={12}
                            md={12}
                            lg={12}
                            className="commTopButtonRightLeftPadding"
                          >
                            <h5 className="bg-table-status bg-table-new-status mt-3 p-3">
                              Sold-to-Party
                            </h5>
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Title"
                              placeholder=""
                              data={getTitle}
                              id="soldToPartyTitleText"
                              iconClassName="dropdownIcon"
                              name="soldToPartyTitleText"
                              setValue={formInputs?.soldToPartyTitleText || ""}
                              getvalue={setDropdownData}
                              // onChangeValue={handleChangeContactInfo}
                              disabled={inRegisterdDisable}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Name"
                              name="soldToPartyname"
                              placeholder=""
                              value={formInputs.soldToPartyname || ""}
                              onChange={onInputChange}
                              disabled={inRegisterdDisable}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Street 1"
                              name="soldToPartystreet1"
                              placeholder=""
                              value={formInputs.soldToPartystreet1 || ""}
                              onChange={onInputChange}
                              disabled={inRegisterdDisable}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Street 2"
                              name="soldToPartystreet2"
                              placeholder=""
                              value={formInputs.soldToPartystreet2 || ""}
                              onChange={onInputChange}
                              disabled={inRegisterdDisable}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Street 3"
                              placeholder=""
                              // data={getCountry}
                              id="soldToPartystreet3"
                              iconClassName="dropdownIcon"
                              name="soldToPartystreet3"
                              value={formInputs.soldToPartystreet3 || ""}
                              onChange={onInputChange}
                              disabled={inRegisterdDisable}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Search Term"
                              placeholder=""
                              // data={getState}
                              // id="state"
                              iconClassName="dropdownIcon"
                              name="soldToPartysearchTerm"
                              value={formInputs?.soldToPartysearchTerm || ""}
                              onChange={onInputChange}
                              disabled={inRegisterdDisable}
                              // getvalue={setDropdownData}
                              // className="dropdownOption"
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Req ID"
                              name="SoldToPartyReqId"
                              placeholder=""
                              value={formInputs?.SoldToPartyReqId || ""}
                              onChange={onInputChange}
                              disabled={inRegisterdDisable}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >                            
                            <ComboboxField
                              label="Country"
                              placeholder=""
                              data={getCountry}
                              id="soldToPartycountry"
                              iconClassName="dropdownIcon"
                              name="soldToPartycountry"
                              code="soldToPartycountryCode"
                              description="soldToPartycountryDesc"
                              setValue={formInputs.soldToPartycountry}
                              getvalue={setDropdownData}
                              required={true}
                              disabled={inRegisterdDisable}
                              // error={validation.soldToPartycountry}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="State"
                              placeholder=""
                              data={getState}
                              id="soldToPartyState"
                              iconClassName="dropdownIcon"
                              name="soldToPartyState"
                              code="soldToPartyStateCode"
                              description="soldToPartyStateDesc"
                              setValue={formInputs.soldToPartyState}
                              getvalue={setDropdownData}
                              required={true}
                              disabled={inRegisterdDisable}
                              // error={validation.soldToPartyState}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="City"
                              name="SoldToPartyCity"
                              placeholder=""
                              value={formInputs.SoldToPartyCity || ""}
                              onChange={onInputChange}
                            />
                          </Col>
                          
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Zip Code"
                              name="soldToPartyZipCode"
                              placeholder=""
                              value={formInputs.soldToPartyZipCode || ""}
                              onChange={onInputChange}
                              disabled={inRegisterdDisable}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Mobile"
                              name="soldToPartyMobile"
                              placeholder=""
                              value={formInputs.soldToPartyMobile || ""}
                              onChange={onInputChange}
                              disabled={inRegisterdDisable}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="TelePhone"
                              name="soldToPartyTelePhone"
                              placeholder=""
                              value={formInputs.soldToPartyTelePhone || ""}
                              onChange={onInputChange}
                              disabled={inRegisterdDisable}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Email"
                              name="soldToPartyEmail"
                              placeholder=""
                              value={formInputs?.soldToPartyEmail || ""}
                              onChange={onInputChange}
                              disabled={inRegisterdDisable}
                            />
                          </Col>
                          <Row>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                label="Terms Of Payment Key"
                                placeholder=""
                                data={getSoldToPartyTermsofPaymentKey}
                                id="soldToPartyTermsofPaymentKey"
                                iconClassName="dropdownIcon"
                                name="soldToPartyTermsofPaymentKey"
                                // code="soldToPartyTermsofPaymentKeyCode"
                                // description="soldToPartyTermsofPaymentKeyDesc"
                                setValue={
                                  formInputs.soldToPartyTermsofPaymentKey
                                }
                                getvalue={setDropdownData}
                                required={true}
                                disabled={inRegisterdDisable}
                                // error={validation.soldToPartyTermsofPaymentKey}
                              />
                            </Col>
                          </Row>

                          <Row>
                            <Col xs={12} md={5} lg={5}>
                              <h5 className="bg-table-status bg-table-warning-status mt-1">
                                Other Details
                              </h5>
                            </Col>
                          </Row>
                          <Row>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="GSTIN Nr"
                                name="soldToPartyGstinNr"
                                placeholder=""
                                value={formInputs?.soldToPartyGstinNr || ""}
                                onChange={onInputChange}
                                disabled={inRegisterdDisable}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="PAN Nr"
                                name="soldToPartyPanNr"
                                placeholder=""
                                value={formInputs?.soldToPartyPanNr || ""}
                                onChange={onInputChange}
                                disabled={inRegisterdDisable}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                label="Folio Code"
                                placeholder=""
                                data={getSoldTopartyFolioCode}
                                id="soldTopartyGrade"
                                iconClassName="dropdownIcon"
                                name="soldTopartyGrade"
                                code="soldTopartyFolioCodeCode"
                                description="soldTopartyGradeDesc"
                                setValue={formInputs.soldTopartyGrade}
                                getvalue={setDropdownData}
                                disabled={inRegisterdDisable}
                                // required={true}
                                // error={validation.soldTopartyGrade}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                label="Grade"
                                placeholder=""
                                data={getSoldTopartyGrade}
                                id="soldTopartyGrade"
                                iconClassName="dropdownIcon"
                                name="soldTopartyGradeCode"
                                // code="soldTopartyGradeCode"
                                // description="soldTopartyFolioCodeDesc"
                                setValue={formInputs.soldTopartyFolioCode}
                                getvalue={setDropdownData}
                                disabled={inRegisterdDisable}
                                // required={true}
                                // error={validation.soldTopartyFolioCode}
                              />
                            </Col>
                          </Row>

                          <Row>
                            <Col xs={12} md={5} lg={5}>
                              <h5 className="bg-table-status bg-table-warning-status mt-1">
                                Area Sales Manager
                              </h5>
                            </Col>
                          </Row>
                          <Row>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Area Sales Manager"
                                placeholder=""
                                name="areaSalesManager"
                                value={formInputs.areaSalesManager || ""}
                                onChange={onInputChange}
                                disabled={inRegisterdDisable}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Name"
                                placeholder=""
                                name="areaSalesManagerName"
                                value={formInputs?.areaSalesManagerName || ""}
                                onChange={onInputChange}
                                disabled={inRegisterdDisable}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Mobile Nr"
                                name="areaSalesManagerMobileNr"
                                placeholder=""
                                value={
                                  formInputs?.areaSalesManagerMobileNr || ""
                                }
                                onChange={onInputChange}
                                disabled={inRegisterdDisable}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Mobile"
                                name="areaSalesManagerMobile"
                                placeholder=""
                                value={formInputs?.areaSalesManagerMobile || ""}
                                onChange={onInputChange}
                                disabled={inRegisterdDisable}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="TelePhone Nr"
                                name="areaSalesManagerTelePhoneNr"
                                placeholder=""
                                value={
                                  formInputs?.areaSalesManagerTelePhoneNr || ""
                                }
                                onChange={onInputChange}
                                disabled={inRegisterdDisable}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Email"
                                name="areaSalesManagerTelePhoneNrEmailId"
                                placeholder=""
                                value={
                                  formInputs?.areaSalesManagerTelePhoneNrEmailId ||
                                  ""
                                }
                                onChange={onInputChange}
                                disabled={inRegisterdDisable}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Carpet Area/Layout"
                                name="areaSalesManagerCarpetArea"
                                placeholder=""
                                value={
                                  formInputs?.areaSalesManagerCarpetArea || ""
                                }
                                onChange={onInputChange}
                                disabled={inRegisterdDisable}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Square Feet"
                                name="areaSalesManagerSquareFeet"
                                placeholder=""
                                value={
                                  formInputs?.areaSalesManagerSquareFeet || ""
                                }
                                onChange={onInputChange}
                                disabled={inRegisterdDisable}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Credit Limit(RS)"
                                name="areaSalesManagerSquareFeetCreditLimit"
                                placeholder=""
                                value={
                                  formInputs.areaSalesManagerSquareFeetCreditLimit ||
                                  ""
                                }
                                onChange={onInputChange}
                                disabled={inRegisterdDisable}
                              />
                            </Col>
                          </Row>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Tax Classification*/}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible13
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility13}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">TC</span>
                        </Col>
                        <Col xs={8} md={9} lg={9}>
                          <span className="headerTitle">
                            Tax Classification
                          </span>
                          <span className="subHeaderTitle">
                            Tax Classification Details
                          </span>
                        </Col>
                      </Row>
                    </h2>

                    <div
                      className={`accordion-collapse collapse show ${
                        isCardVisible13 ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4">
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="TCS/TDS"
                              placeholder=""
                              data={getTaxClassificationTCSTDS}
                              id="taxClassificationTCSTDS"
                              iconClassName="dropdownIcon"
                              name="taxClassificationTCSTDS"
                              code="taxClassificationTCSTDSCode"
                              description="taxClassificationTCSTDSDesc"
                              setValue={formInputs?.taxClassificationTCSTDS}
                              getvalue={setDropdownData}
                              disabled={inRegisterdDisable}
                              // error={validation?.taxClassificationTCSTDS}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Applicable"
                              name="getTcsTdsApplicabel"
                              placeholder=""
                              value={
                                getTcsTdsApplicabel ??
                                formInputs?.getTcsTdsApplicabel ??
                                ""
                              }
                              // onChange={onInputChange}
                              disabled={true}
                              // required={true}
                              // error={validation.organisationName}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Invoice"
                              name="getTcsTdsInvoice"
                              placeholder=""
                              // value={getTcsTdsInvoice || ""}
                              value={
                                getTcsTdsInvoice ??
                                formInputs?.getTcsTdsInvoice ??
                                ""
                              }
                              // onChange={onInputChange}
                              disabled={true}
                              // required={true}
                              // error={validation.organisationName}
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Bill to Party */}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible14
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility14}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">BP</span>
                        </Col>
                        <Col xs={12} md={9} lg={9}>
                          <span className="headerTitle">Bill To Party</span>
                          <span className="subHeaderTitle">
                            Bill To Party Details
                          </span>
                        </Col>

                        <Col xs={2} md={1} lg={1} className="">
                          <CommonFillter />
                        </Col>
                      </Row>
                    </h2>

                    <div
                      className={`accordion-collapse collapse show ${
                        isCardVisible14 ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4">
                          <Col
                            xs={12}
                            md={12}
                            lg={12}
                            className="commTopButtonRightLeftPadding"
                          >
                            <h5 className="bg-table-status bg-table-new-status mt-3 p-3">
                              Bill-to-Party
                            </h5>
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Title"
                              placeholder=""
                              data={getTitle}
                              id="billToPartyTitleText"
                              iconClassName="dropdownIcon"
                              name="billToPartyTitleText"
                              setValue={formInputs?.billToPartyTitleText || ""}
                              getvalue={setDropdownData}
                              // onChangeValue={handleChangeContactInfo}
                              disabled={inRegisterdDisable}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Name"
                              name="billToPartyname"
                              placeholder=""
                              value={formInputs?.billToPartyname || ""}
                              onChange={onInputChange}
                              disabled={inRegisterdDisable}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Street 1"
                              name="billToPartystreet1"
                              placeholder=""
                              value={formInputs?.billToPartystreet1 || ""}
                              onChange={onInputChange}
                              disabled={inRegisterdDisable}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Street 2"
                              name="billToPartystreet2"
                              placeholder=""
                              value={formInputs?.billToPartystreet2 || ""}
                              onChange={onInputChange}
                              disabled={inRegisterdDisable}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Street 3"
                              placeholder=""
                              // data={getCountry}
                              id="billToPartystreet3"
                              iconClassName="dropdownIcon"
                              name="billToPartystreet3"
                              value={formInputs?.billToPartystreet3 || ""}
                              onChange={onInputChange}
                              disabled={inRegisterdDisable}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Search Term"
                              placeholder=""
                              // data={getState}
                              // id="state"
                              iconClassName="dropdownIcon"
                              name="billToPartysearchTerm"
                              value={formInputs?.billToPartysearchTerm || ""}
                              onChange={onInputChange}
                              disabled={inRegisterdDisable}

                              // getvalue={setDropdownData}
                              // className="dropdownOption"
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Req ID"
                              name="billToPartyReqId"
                              placeholder=""
                              value={formInputs?.billToPartyReqId || ""}
                              onChange={onInputChange}
                              disabled={inRegisterdDisable}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Country"
                              placeholder=""
                              data={getCountry}
                              id="billToPartycountry"
                              iconClassName="dropdownIcon"
                              name="billToPartycountry"
                              code="billToPartycountryCode"
                              description="billToPartycountryDesc"
                              setValue={formInputs.billToPartycountry}
                              getvalue={setDropdownData}
                              required={true}
                              disabled={inRegisterdDisable}
                              // error={validation.billToPartycountry}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="State"
                              placeholder=""
                              data={getState}
                              id="billToPartyState"
                              iconClassName="dropdownIcon"
                              name="billToPartyState"
                              code="billToPartyStateCode"
                              description="billToPartyStateDesc"
                              setValue={formInputs.billToPartyState}
                              getvalue={setDropdownData}
                              required={true}
                              disabled={inRegisterdDisable}
                              // error={validation.billToPartyState}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Zip Code"
                              name="billToPartyZipCode"
                              placeholder=""
                              value={formInputs?.billToPartyZipCode || ""}
                              onChange={onInputChange}
                              disabled={inRegisterdDisable}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="City"
                              name="billToPartyCity"
                              placeholder=""
                              value={formInputs.billToPartyCity || ""}
                              onChange={onInputChange}
                              disabled={inRegisterdDisable}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Mobile"
                              name="billToPartyMobile"
                              placeholder=""
                              value={formInputs?.billToPartyMobile || ""}
                              onChange={onInputChange}
                              disabled={inRegisterdDisable}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="TelePhone"
                              name="billToPartyTelePhone"
                              placeholder=""
                              value={formInputs?.billToPartyTelePhone || ""}
                              onChange={onInputChange}
                              disabled={inRegisterdDisable}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Email"
                              name="billToPartyEmail"
                              placeholder=""
                              value={formInputs?.billToPartyEmail || ""}
                              onChange={onInputChange}
                              disabled={inRegisterdDisable}
                            />
                          </Col>
                          <Row>
                            <Col xs={12} md={5} lg={5}>
                              <h5 className="bg-table-status bg-table-warning-status mt-1">
                                Other Details
                              </h5>
                            </Col>
                          </Row>
                          <Row>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="GSTIN Nr"
                                name="billToPartyGstinNr"
                                placeholder=""
                                value={formInputs?.billToPartyGstinNr || ""}
                                onChange={onInputChange}
                                disabled={inRegisterdDisable}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="PAN Nr"
                                name="billToPartyPanNr"
                                placeholder=""
                                value={formInputs?.billToPartyPanNr || ""}
                                onChange={onInputChange}
                                disabled={inRegisterdDisable}
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col xs={12} md={5} lg={5}>
                              <h5 className="bg-table-status bg-table-warning-status mt-1">
                                Payer
                              </h5>
                            </Col>
                          </Row>
                          <Row>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                label="Title"
                                placeholder=""
                                data={getTitle}
                                id="payerToPartyTitleText"
                                iconClassName="dropdownIcon"
                                name="payerToPartyTitleText"
                                setValue={
                                  formInputs?.payerToPartyTitleText || ""
                                }
                                getvalue={setDropdownData}
                                // onChangeValue={handleChangeContactInfo}
                                disabled={inRegisterdDisable}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Name"
                                name="payerToPartyname"
                                placeholder=""
                                value={formInputs?.payerToPartyname || ""}
                                onChange={onInputChange}
                                disabled={inRegisterdDisable}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Street 1"
                                name="payerToPartystreet1"
                                placeholder=""
                                value={formInputs?.payerToPartystreet1 || ""}
                                onChange={onInputChange}
                                disabled={inRegisterdDisable}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Street 2"
                                name="payerToPartystreet2"
                                placeholder=""
                                value={formInputs?.payerToPartystreet2 || ""}
                                onChange={onInputChange}
                                disabled={inRegisterdDisable}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Street 3"
                                placeholder=""
                                // data={getCountry}
                                id="payerToPartystreet3"
                                iconClassName="dropdownIcon"
                                name="payerToPartystreet3"
                                value={formInputs?.payerToPartystreet3 || ""}
                                onChange={onInputChange}
                                disabled={inRegisterdDisable}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Search Term"
                                placeholder=""
                                // data={getState}
                                // id="state"
                                iconClassName="dropdownIcon"
                                name="payerToPartysearchTerm"
                                value={formInputs?.payerToPartysearchTerm || ""}
                                onChange={onInputChange}
                                disabled={inRegisterdDisable}
                                // getvalue={setDropdownData}
                                // className="dropdownOption"
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Req ID"
                                name="payerToPartyReqId"
                                placeholder=""
                                value={formInputs?.payerToPartyReqId || ""}
                                onChange={onInputChange}
                                disabled={inRegisterdDisable}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                label="Country"
                                placeholder=""
                                data={getCountry}
                                id="payerToPartycountry"
                                iconClassName="dropdownIcon"
                                name="payerToPartycountry"
                                code="payerToPartycountryCode"
                                description="payerToPartycountryDesc"
                                setValue={formInputs?.payerToPartycountry}
                                getvalue={setDropdownData}
                                required={true}
                                disabled={inRegisterdDisable}
                                // error={validation?.payerToPartycountry}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                label="State"
                                placeholder=""
                                data={getState}
                                id="payerToPartyState"
                                iconClassName="dropdownIcon"
                                name="payerToPartyState"
                                code="payerToPartyStateCode"
                                description="payerToPartyStateDesc"
                                setValue={formInputs.payerToPartyState}
                                getvalue={setDropdownData}
                                required={true}
                                disabled={inRegisterdDisable}
                                // error={validation.payerToPartyState}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Zip Code"
                                name="payerToPartyZipCode"
                                placeholder=""
                                value={formInputs?.payerToPartyZipCode || ""}
                                onChange={onInputChange}
                                disabled={inRegisterdDisable}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="City"
                                name="payerToPartyCity"
                                placeholder=""
                                value={formInputs.payerToPartyCity || ""}
                                onChange={onInputChange}
                                disabled={inRegisterdDisable}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Mobile"
                                name="payerToPartyMobile"
                                placeholder=""
                                value={formInputs?.payerToPartyMobile || ""}
                                onChange={onInputChange}
                                disabled={inRegisterdDisable}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="TelePhone"
                                name="payerToPartyTelePhone"
                                placeholder=""
                                value={formInputs?.payerToPartyTelePhone || ""}
                                onChange={onInputChange}
                                disabled={inRegisterdDisable}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Email"
                                name="payerToPartyEmail"
                                placeholder=""
                                value={formInputs?.payerToPartyEmail || ""}
                                onChange={onInputChange}
                                disabled={inRegisterdDisable}
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col xs={12} md={5} lg={5}>
                              <h5 className="bg-table-status bg-table-warning-status mt-1">
                                Other Details
                              </h5>
                            </Col>
                          </Row>
                          <Row>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="GSTIN Nr"
                                name="payerToPartyGstinNr"
                                placeholder=""
                                value={formInputs?.payerToPartyGstinNr || ""}
                                onChange={onInputChange}
                                disabled={inRegisterdDisable}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="PAN Nr"
                                name="payerToPartyPanNr"
                                placeholder=""
                                value={formInputs?.payerToPartyPanNr || ""}
                                onChange={onInputChange}
                                disabled={inRegisterdDisable}
                              />
                            </Col>
                          </Row>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </Col>
      </Row>

      {/* <CategorySelectionModal
        // show={modalShowCat}
        // onHide={() => hideModalCat()}
      /> */}

      <ApproveRemarksModal
        show={modalShow}
        onHide={() => hideModal()}
        onvaluechange={handleValueChange}
      />

      {/* Success Modal */}
      <SuccessModal
        show={getShowSuccessModal}
        onHide={() => hideSuccessModal()}
        successmodaldata={getsucceModalData}
        nextnavigate={getNextNavigate}
      />
      <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />
    </main>
  );
};

export default CustomerDetailedPageV4Workflow;
